import { render, staticRenderFns } from "./CollectionRequest.vue?vue&type=template&id=35fe685c&"
import script from "./CollectionRequest.vue?vue&type=script&lang=ts&"
export * from "./CollectionRequest.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports